import React from 'react'
import Header from '../components/Header'
import locale from '../locale'
import Hero from '../components/Hero'
import en from '../locale/en'
import cn from '../locale/cn'
import InfoBlockGrid from '../components/InfoBlockGrid'
import HorizontalInfoBlock from '../components/HorizontalInfoBlock'
import SectionHeader from '../components/SectionHeader'
import SubsectionHeader from '../components/SubsectionHeader'
import CardGrid from '../components/CardGrid'
import LinkBox from '../components/LinkBox'
import Layout from '../components/Layout'
import Footer from '../components/Footer'
import { graphql } from 'gatsby'
import './page.css'
import violinEN from '../pdfs/2020-audition-excerpts/violin_en.pdf';
import violinCN from '../pdfs/2020-audition-excerpts/violin_cn.pdf';
import violaEN from '../pdfs/2020-audition-excerpts/viola_en.pdf';
import violaCN from '../pdfs/2020-audition-excerpts/viola_cn.pdf';
import celloEN from '../pdfs/2020-audition-excerpts/cello_en.pdf';
import celloCN from '../pdfs/2020-audition-excerpts/cello_cn.pdf';
import bassEN from '../pdfs/2020-audition-excerpts/bass_en.pdf';
import bassCN from '../pdfs/2020-audition-excerpts/bass_cn.pdf';
import fluteEN from '../pdfs/2020-audition-excerpts/flute_en.pdf';
import fluteCN from '../pdfs/2020-audition-excerpts/flute_cn.pdf';
import oboeEN from '../pdfs/2020-audition-excerpts/oboe_en.pdf';
import oboeCN from '../pdfs/2020-audition-excerpts/oboe_cn.pdf';
import clarinetEN from '../pdfs/2020-audition-excerpts/clarinet_en.pdf';
import clarinetCN from '../pdfs/2020-audition-excerpts/clarinet_cn.pdf';
import bassoonEN from '../pdfs/2020-audition-excerpts/bassoon_en.pdf';
import bassoonCN from '../pdfs/2020-audition-excerpts/bassoon_cn.pdf';
import frenchhornEN from '../pdfs/2020-audition-excerpts/french_horn_en.pdf';
import frenchhornCN from '../pdfs/2020-audition-excerpts/french_horn_cn.pdf';
import trumpetEN from '../pdfs/2020-audition-excerpts/trumpet_en.pdf';
import trumpetCN from '../pdfs/2020-audition-excerpts/trumpet_cn.pdf';


let data = { en, cn };
let localizedData = () => data[locale.getLocale()];
let header_data = localizedData().header;
let auditions_data = localizedData().auditions;
let isShort = true;

class AuditionsPage extends React.Component {

    constructor(props) {
      super(props);

      this.state = {
        isShiftedLeft: false,
      }

      this.shiftLeft = this.shiftLeft.bind(this);
      this.shiftRight = this.shiftRight.bind(this);
    }

    shiftLeft() {
      this.setState({isShiftedLeft: true});
    }

    shiftRight() {
      this.setState({isShiftedLeft: false});
    }

    render() {
      let excerpts = [
        violinEN,
        violinCN,
        violaEN,
        violaCN,
        celloEN,
        celloCN,
        bassEN,
        bassCN,
        fluteEN,
        fluteCN,
        clarinetEN,
        clarinetCN,
        bassoonEN,
        bassoonCN,
        oboeEN,
        oboeCN,
        frenchhornEN,
        frenchhornCN,
        trumpetEN,
        trumpetCN,
      ];

      return (
        <div className={"page " + (this.state.isShiftedLeft ? "left-shift" : "neutral-shift")}>
        <Layout>
        <Header
          onBMOpen={this.shiftLeft}
          onBMClose={this.shiftRight}
          fluid={this.props.data.logoImage.childImageSharp.fluid}
          data={header_data}>
        </Header>

        <Hero
          isShort = {isShort}
          fluid = {this.props.data.heroImage.childImageSharp.fluid}
          data={auditions_data.hero}>
        </Hero>

        <div className="cropped-width">

          <SectionHeader data={auditions_data.header}></SectionHeader>

          <div style={{marginTop: '-50px'}}></div>

          <LinkBox data = {auditions_data.apply} type="black"></LinkBox>

          <SubsectionHeader
            data={auditions_data.components.header}></SubsectionHeader>

          <div style={{marginTop: '-70px'}}></div>

          <CardGrid
              nCellsPerRow = {4}
              nCellsPerRowMobile = {1}
              data = {auditions_data.components.excerpts}
              links = {excerpts}
              images = {this.props.data.excerptsImages.edges}
            ></CardGrid>

          <br></br><br></br>

        </div>

        <Footer></Footer>

        </Layout>


      </div>
    )
  }
}

export default AuditionsPage;

export const pageQuery = graphql`
  query AuditionsQuery {
    logoImage: file(relativePath: { eq: "logo_white.png" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    },
    heroImage: file(relativePath: { eq: "auditions/hero.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 2000) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    },
    excerptsImages: allFile(filter: { relativeDirectory: { eq: "auditions/excerpts" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 400) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    },
  }
`;
